import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";

const AllStudentReservationsCheckbox = ({
	eventData,
	studentReservations,
	setCanShowDialogLeavingPage,
	attendanceAllStudents,
	errorSaveAttendance,
}) => {
	const changeAttendanceAllStudents = () => {
		if (attendanceAllStudents) {
			studentReservations.set(
				studentReservations.value.map(student => ({
					...student,
					attendance: false,
				}))
			);
			return;
		}
		studentReservations.set(
			studentReservations.value.map(student => ({
				...student,
				attendance: true,
			}))
		);
		// Habilitando aviso de salida sin guardar
		setCanShowDialogLeavingPage(true);
	};
	return (
		<CustomCheckbox
			variant="box"
			disabled={!eventData.isPresential}
			onChange={changeAttendanceAllStudents}
			checked={attendanceAllStudents}
			error={errorSaveAttendance.value}
		/>
	);
};

export default AllStudentReservationsCheckbox;
